import { Navigate, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useAdvisor, INITIAL } from "@/advisor/AdvisorContext";
import { useSite } from "@/context/SiteContext";
import { WhatsAppIcon, waLink } from "@/components/site/Socials";
import { Icon } from "@/advisor/icons";

export default function AdvisorSuccess() {
  const { state, bySlug, update } = useAdvisor();
  const { config } = useSite();
  const nav = useNavigate();
  const lead = state.lastLead;
  if (!lead) return <Navigate to="/advisor" replace />;

  const wa = config.contacts?.whatsapp || config.contacts?.phone || "";
  const names = lead.selected.map((s) => bySlug[s]?.name || s);
  const msg = `Salam! LiveMedia Business Advisor vasitəsilə sorğu göndərdim (${lead.code}). ${lead.business ? `Biznes: ${lead.business.label}. ` : ""}Həllər: ${names.join(", ")}.`;

  const home = () => {
    update({ ...INITIAL });
    nav("/");
  };

  return (
    <div className="max-w-lg mx-auto px-5 sm:px-6 pt-[120px] pb-24" data-testid="success-container">
      <motion.div initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="h-16 w-16 rounded-2xl bg-[#171715] text-[#D6AD62] grid place-items-center">
        <CheckCircle2 className="h-9 w-9" />
      </motion.div>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold mt-6">Sorğunuz qəbul edildi</h1>
      <p className="text-[#2d2c29] mt-3 leading-relaxed">LiveMedia komandası seçdiyiniz həlləri nəzərdən keçirərək sizinlə əlaqə saxlayacaq.</p>
      <p className="text-xs text-[#77736B] font-mono mt-2" data-testid="success-code">Sorğu kodu: {lead.code}</p>

      <div className="adv-card p-5 mt-6">
        <div className="adv-eyebrow mb-3">Sizin layihəniz</div>
        <ul className="space-y-2" data-testid="success-project-list">
          {lead.business && <li className="flex items-center gap-3 font-semibold"><Icon name={lead.business?.icon} className="h-5 w-5 text-[#D6AD62]" /> {lead.business.label}</li>}
          {lead.selected.map((s) => (
            <li key={s} className="flex items-center gap-3 text-[#E9E3D8]"><Icon name={bySlug[s]?.icon} className="h-5 w-5 text-[#F3D592]" /> {bySlug[s]?.name || s}</li>
          ))}
        </ul>
      </div>

      {wa && (
        <a href={`${waLink(wa)}?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" className="btn-gold w-full justify-center mt-6" data-testid="btn-whatsapp-share">
          <WhatsAppIcon /> WhatsApp-da davam et
        </a>
      )}
      <button onClick={home} className="btn-ghost w-full justify-center mt-3" data-testid="btn-back-home">Ana səhifəyə qayıt</button>
    </div>
  );
}
